/*
 * General custom scripts
 */

import { Header } from './front/Header';
import { TopBar } from './front/TopBar';
import { LanguageSwitcher } from './front/LanguageSwitcher';
import { CookieBot } from './front/CookieBot';
// Import Lottie animations for tiles
import './lottie-tiles';

window.addEventListener( 'DOMContentLoaded', () => {

	new Header();
	new TopBar();

	// Initialize language switchers
	const switchers = document.querySelectorAll( '.language-switcher' );
	switchers.forEach( ( element ) => new LanguageSwitcher( element ) );

} );

window.addEventListener( 'CookiebotOnLoad', () => {

	new CookieBot();

} );
